import React from "react";
import { observer } from "mobx-react";

const SummaryCardBlock = observer(({ block }) => (
  <div className="copilotSummary">
    {block.title && <div className="copilotSummary__title">{block.title}</div>}
    <div className="copilotSummary__rows">
      {(block.rows || []).map(row => (
        <div className="copilotSummary__row" key={row.label}>
          <span className="copilotSummary__label">{row.label}</span>
          <span
            className={`copilotSummary__value tone-${row.tone || "default"}`}
          >
            {row.value}
          </span>
        </div>
      ))}
    </div>
    {block.footnote && (
      <div className="copilotSummary__footnote">{block.footnote}</div>
    )}
  </div>
));

export default SummaryCardBlock;
